import { H2RInput, H2RSelect } from "../../imports";
import OpenExternal from "../helpers/OpenExternal";
import { replaceWithDataSource } from "../helpers/variable";
import TimeToTimeOfDay from "../output/TimeToTimeOfDay";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Display format (Large text)"
				value={cue.format}
				placeholder="HH:mm:ss"
				onChange={(value) => {
					onUpdate({ format: value });
				}}
			/>
			<OpenExternal
				buttonText={"More formatting options"}
				isElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
				isNotElectronLink={`https://docs.h2r.graphics/graphics/time#display-format`}
			/>
			<H2RInput
				label="End time (HH:MM:SS)"
				type="datetime-local"
				value={cue.endTime}
				placeholder="e.g. 00:01:00 = 1 minute"
				onChange={(value) => {
					onUpdate({ endTime: value });
				}}
			/>

			<H2RInput
				label="Pre message (Small text)"
				value={cue.pre}
				onChange={(value) => {
					onUpdate({ pre: value });
				}}
			/>

			<H2RSelect
				label="On end"
				selected={cue.onEnd || "negative"}
				onChange={(value) => {
					onUpdate({ onEnd: value });
				}}
				options={[
					{
						label: "Show negative numbers",
						value: "negative",
					},
					{
						label: "Hold on 00:00:00",
						value: "hold",
					},
				]}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
						${twoLines ? "whitespace-normal" : "whitespace-nowrap"}
		`}
		>
			<span
				style={{ fontVariantNumeric: "tabular-nums" }}
				className="font-semibold inline-block"
			>
				<TimeToTimeOfDay cue={cue} cuePreview={true} />
			</span>
			<span className="pl-2 text-xs text-gray-300">
				{replaceWithDataSource(cue.pre, dynamicText, dynamicLists, true) || ""}
			</span>
		</div>
	);
};
